import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, shallowRef } from "vue";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_PROJECT_MERGE } from "@/configs/Apis";
import { showConfirm, showSuccess } from "@/utils/UI";
import { isEmptyOrWhiteSpace } from "@/utils/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectMergeDialog',
  props: {
  mergingProjects: { type: Array, required: true, default: () => [] },
},
  emits: ["saved"],
  setup(__props, { expose, emit }) {

const props = __props;





const visible = ref(false);
const form = shallowRef<any>(null);

const formData = reactive({
  create: false,
  main1: "",
  main2: "",
  newName: "",
  remark: "",
});

const rules = computed(() => ({
  newName: [
    {
      validator: (rule: any, value: any, callback: (...args: any[]) => void) => {
        if (formData.create && isEmptyOrWhiteSpace(formData.newName)) {
          callback(new Error("请输入数据库名称"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
}));

const open = (mergingList: Array<any> = props.mergingProjects as Array<any>) => {
  Object.assign(formData, { create: false, main1: "", main2: "", newName: "", remark: "" });
  const item1: any = mergingList[0];
  if (item1) {
    formData.main1 = item1.id;
    formData.main2 = item1.id;
  }
  visible.value = true;
};

const save = async () => {
  const isValid = await form.value.validate().catch(() => false);
  if (!isValid) {
    return;
  }
  const confirmed: any = await showConfirm("是否确认合并数据库？").catch(() => "");
  if (!confirmed) {
    return;
  }
  const mergingList = props.mergingProjects as Array<any>;
  const postedData: any = {
    primaryId: "",
    secondaryId: "",
    create: formData.create,
    remark: formData.remark,
    name: undefined,
  };

  if (formData.create) {
    postedData.primaryId = formData.main2;
    postedData.name = formData.newName;
  } else {
    postedData.primaryId = formData.main1;
  }
  // 寻找次级项目
  const foundItem = mergingList.filter((item) => item.id === postedData.primaryId);
  if (foundItem.length) {
    const index = mergingList.indexOf(foundItem[0]);
    postedData.secondaryId = mergingList[1 - index].id;
  }
  await DuduAjax.post(API_BIS_PROJECT_MERGE, postedData);
  showSuccess("合并成功");
  visible.value = false;
  emit("saved");
};

expose({ open });

return { __sfc: true,props, emit, visible, form, formData, rules, open, save }
}

})